module.exports = __webpack_public_path__ + "img/step4-1.1fd1a78a.png";